import { toast } from "react-toastify";
import { TABLE_HEAD_POSITIONS } from "../../component/Methods";

export function getPositionsExportHeaders() {
  return TABLE_HEAD_POSITIONS.filter((col) => col.id !== "actions");
}

function escapeCsvCell(value) {
  const str = value === undefined || value === null ? "" : String(value);
  const sanitized = str.replace(/\r?\n/g, " ");
  if (/[",]/.test(sanitized)) {
    return `"${sanitized.replace(/"/g, '""')}"`;
  }
  return sanitized;
}

export function formatPositionExportCell(columnId, row) {
  switch (columnId) {
    case "positionType":
      return row?.positionType || "-";
    case "tickerSymbol":
      return row?.tickerSymbol ? row.tickerSymbol.toUpperCase() : "-";
    case "investmentType":
      return row?.investmentType || "-";
    case "fundName":
      return row?.fundName || "-";
    case "strategyName":
      return row?.strategyName || "-";
    case "custodianName":
      return row?.custodianName || "-";
    case "shares": {
      const shares = row?.shares;
      if (!shares) return "-";
      return shares < 0
        ? `(${Math.abs(shares).toLocaleString()})`
        : shares.toLocaleString();
    }
    case "averageCostPerShare":
      return row?.averageCostPerShare ? `$${row.averageCostPerShare.toFixed(2)}` : "-";
    case "price":
      return row?.price ? `$${row.price.toFixed(2)}` : "-";
    default:
      return row?.[columnId] ?? "";
  }
}

export function buildPositionsCsv(positions) {
  const headers = getPositionsExportHeaders();
  const headerLine = headers.map((col) => escapeCsvCell(col.label)).join(",");
  const dataLines = (positions ?? []).map((row) =>
    headers
      .map((col) => escapeCsvCell(formatPositionExportCell(col.id, row)))
      .join(",")
  );
  return [headerLine, ...dataLines].join("\n");
}

export function getPositionsExportFileName() {
  const date = new Date();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  const year = String(date.getFullYear()).slice(-2);
  return `positions_${month}-${day}-${year}.csv`;
}

export function downloadPositionsCsv(positions) {
  if (!positions?.length) {
    toast.error("No positions to export");
    return;
  }

  try {
    const csvContent = buildPositionsCsv(positions);
    const blob = new Blob(["\uFEFF", csvContent], {
      type: "text/csv;charset=utf-8;",
    });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = getPositionsExportFileName();
    link.rel = "noopener";
    link.style.display = "none";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.setTimeout(() => URL.revokeObjectURL(url), 500);
    toast.success("Positions exported");
  } catch (error) {
    console.error("Error exporting positions CSV:", error);
    toast.error("Failed to export positions");
  }
}
